import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServiceConfigService } from '@app/services/service-config.service';
import { TokenService } from './token/token.service';

@Injectable({
  providedIn: 'root'
})
export class SubmissionStatusService {

  constructor(private http: HttpClient, private serverConfig: ServiceConfigService, private token: TokenService) { }
  apiContext = `easy-app/api`;

  getAppStatus(wAppNumber) {
    return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}${this.apiContext}/indi/appstatustracker/getAppStatus/appNum/${wAppNumber}`, { headers: new HttpHeaders({ 'pageId': 'TCCST', 'sessionId' : this.token.getSessionId() }) })
  }

  getSubmittedAppDetails(indivId, accountType) {
    return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}${this.apiContext}/indi/appstatustracker/getAllAppsDetails/accountType/${accountType}/indv/${indivId}`, { headers: new HttpHeaders({ 'pageId': 'TCCDT', 'sessionId' : this.token.getSessionId() }) })
  }

  getAppealsStatus(indivId) {
    return this.http.get(`${this.serverConfig.getServerConfig()['gatewayURL']}${this.apiContext}/indi/appstatustracker/getAppealsStatus/indv/${indivId}`, { headers: new HttpHeaders({ 'pageId': 'TCCAS', 'sessionId' : this.token.getSessionId() }) })
  }
}
